import { render, staticRenderFns } from "./PlotEdit.vue?vue&type=template&id=4521f0a9"
import script from "./PlotEdit.vue?vue&type=script&lang=ts"
export * from "./PlotEdit.vue?vue&type=script&lang=ts"
import style0 from "./PlotEdit.vue?vue&type=style&index=0&id=4521f0a9&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4521f0a9')) {
      api.createRecord('4521f0a9', component.options)
    } else {
      api.reload('4521f0a9', component.options)
    }
    module.hot.accept("./PlotEdit.vue?vue&type=template&id=4521f0a9", function () {
      api.rerender('4521f0a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/PlotEdit.vue"
export default component.exports